import { Ban } from "lucide-react";

export const ModuleUnavailable = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50 px-6" data-testid="module-unavailable">
    <div className="max-w-md text-center">
      <div className="mx-auto h-14 w-14 rounded-full bg-slate-200 flex items-center justify-center mb-5">
        <Ban className="h-7 w-7 text-slate-500" />
      </div>
      <h1 className="text-2xl font-semibold text-slate-800">This module is unavailable</h1>
      <p className="text-sm text-slate-500 mt-2">It has been switched off by ZKTeco UK. Please contact uk.office@zkteco.co.uk if you need access.</p>
      <a href="/" data-testid="module-unavailable-home" className="inline-block mt-6 text-sm font-medium text-white bg-slate-800 hover:bg-slate-700 transition-colors rounded-md px-4 py-2">
        Go to the configurator
      </a>
    </div>
  </div>
);
